import styled from "styled-components";

const getColor = color => {
  const colors = {
    primary: "#7367f0",
    danger: "#ea5455",
    warning: "#ff9f43",
    success: "#28c76f",
    info: "#00cfe8",
    secondary: "#82868b",
  };
  return colors[color] || colors.primary;
};

const getColorRgba = (color, opacity = 0.16) => {
  const colorHex = getColor(color);
  const r = parseInt(colorHex.slice(1, 3), 16);
  const g = parseInt(colorHex.slice(3, 5), 16);
  const b = parseInt(colorHex.slice(5, 7), 16);
  return `rgba(${r}, ${g}, ${b}, ${opacity})`;
};

export const Container = styled.div`
  width: 100%;
  padding: 10px 0;
`;

export const NouiContainer = styled.div`
  width: 100%;
  padding: 20px 10px;

  .noUi-target {
    background: #e0e0e0;
    border-radius: 4px;
    border: none;
    box-shadow: none;
  }

  .noUi-connect {
    background: ${props => getColor(props.color)};
  }

  .noUi-horizontal {
    height: 8px;
  }

  .noUi-handle {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: ${props => getColor(props.color)};
    border: none;
    box-shadow: 0 2px 4px ${props => getColorRgba(props.color, 0.3)};
    cursor: pointer;
    top: -6px;

    &:before,
    &:after {
      display: none;
    }

    &:hover,
    &:focus {
      box-shadow: 0 0 0 8px ${props => getColorRgba(props.color, 0.16)};
      outline: none;
    }
  }

  .noUi-tooltip {
    background: ${props => getColor(props.color)};
    height: 24px;
    color: white;
    border: none;
    border-radius: 4px;
    padding: 4px 8px;
    font-size: 12px;
    font-weight: 600;

    ${props => {
      switch (props.placement) {
        case "top":
          return `
            bottom: 30px;
            &:before {
              content: "";
              position: absolute;
              bottom: -4px;
              left: 50%;
              transform: translateX(-50%);
              width: 0;
              height: 0;
              border-left: 4px solid transparent;
              border-right: 4px solid transparent;
              border-top: 4px solid ${props => getColor(props.color)};
            }
          `;
        case "bottom":
          return `
            top: 30px;
            bottom: auto;
            &:before {
              content: "";
              position: absolute;
              top: -4px;
              left: 50%;
              transform: translateX(-50%);
              width: 0;
              height: 0;
              border-left: 4px solid transparent;
              border-right: 4px solid transparent;
              border-bottom: 4px solid ${props => getColor(props.color)};
            }
          `;
        case "left":
          return `
            right: 35px;
            left: auto;
            bottom: auto;
            top: 50%;
            transform: translateY(-50%);
            &:before {
              content: "";
              position: absolute;
              right: -4px;
              top: 50%;
              transform: translateY(-50%);
              width: 0;
              height: 0;
              border-top: 4px solid transparent;
              border-bottom: 4px solid transparent;
              border-left: 4px solid ${props => getColor(props.color)};
            }
          `;
        case "right":
          return `
            left: 35px;
            right: auto;
            bottom: auto;
            top: 50%;
            transform: translateY(-25%);
            &:before {
              content: "";
              position: absolute;
              left: -4px;
              top: 50%;
              transform: translateY(-50%);
              width: 0;
              height: 0;
              border-top: 4px solid transparent;
              border-bottom: 4px solid transparent;
              border-right: 4px solid ${props => getColor(props.color)};
            }
          `;
        case "center":
          return `
            left: 10px;
            top: -5px;
            transform: translateY(-25%);
          `;
        default:
          return `
            bottom: 30px;
            &:before {
              content: "";
              position: absolute;
              bottom: -4px;
              left: 50%;
              transform: translateX(-50%);
              width: 0;
              height: 0;
              border-left: 4px solid transparent;
              border-right: 4px solid transparent;
              border-top: 4px solid ${props => getColor(props.color)};
            }
          `;
      }
    }}
  }

  .noUi-pips {
    .noUi-value {
      color: #6e6b7b;
      font-size: 11px;
    }

    .noUi-marker {
      background: #d8d6de;
    }
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
